export const userRoutes = {
  getProfile: 'v3/user/profile',
  getTradingAccounts: 'v3/user/trading-accounts',
  getSettings: 'v3/user/settings',
} as const;
